
export const setTitles = (state, payload) => {
  state.titles = payload;  
};